module.exports = __webpack_public_path__ + "static/media/customize_Icon.ec19a4b9.svg";